module.exports = __webpack_public_path__ + "static/media/sso-verification.dd759fe1.svg";